import { createSelector } from '@ngrx/store';

import { getCitation } from './get.citations';

export const getCitationUpdate = createSelector(
  getCitation,
  ({ isCitationUpdated }): boolean => isCitationUpdated
);
